const state = {
  dialogs: []
}

let dialogIdSeq = 0

const mutations = {
  push(state, dialog) {
    state.dialogs.push({
      id: ++dialogIdSeq,
      ...dialog
    })
  },

  removeById(state, id) {
    state.dialogs = state.dialogs.filter(d => d.id !== id)
  },

  clear(state) {
    state.dialogs = []
  }
}

const actions = {
  showDialog({ commit }, options) {
    return new Promise((resolve) => {
      commit('push', {
        ...options,
        resolve
      })
    })
  },

  closeDialog({ commit, state }, payload) {
    let id, result
    if (
      payload &&
      typeof payload === 'object' &&
      Object.prototype.hasOwnProperty.call(payload, '__dialogId')
    ) {
      id = payload.__dialogId
      result = payload.result
    } else {
      result = payload
      id = state.dialogs[state.dialogs.length - 1]?.id
    }
    const dialog = state.dialogs.find(d => d.id === id)
    if (dialog) {
      dialog.resolve(result)
      commit('removeById', id)
    }
  }
}

const getters = {
  currentDialog: (state) => state.dialogs[state.dialogs.length - 1],
  topDialog: (state) => state.dialogs[state.dialogs.length - 1],
  hasDialog: (state) => state.dialogs.length > 0
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
